import { useScrollReveal } from '@/hooks/useScrollReveal';

const advantages = [
  'Без оплаты за клики и охваты',
  'ИИ пишет первым и напоминает клиентам',
  'Передаём заявки в CRM или менеджеру',
];

export default function LTKHero() {
  const { ref: headlineRef, revealed: headlineRevealed } = useScrollReveal({ delay: 200 });
  const { ref: subtitleRef, revealed: subtitleRevealed } = useScrollReveal({ delay: 350 });
  const { ref: advantagesRef, revealed: advantagesRevealed } = useScrollReveal({ delay: 500 });
  const { ref: btnRef, revealed: btnRevealed } = useScrollReveal({ delay: 650 });

  return (
    <section className="relative w-full min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'radial-gradient(circle, oklch(var(--primary-500)) 1px, transparent 1px)',
          backgroundSize: '28px 28px',
        }}
      />

      <div className="absolute top-20 right-0 w-[600px] h-[600px] opacity-[0.06]" style={{ background: 'radial-gradient(circle at center, oklch(var(--primary-500)), transparent 70%)' }} />
      <div className="absolute bottom-10 left-0 w-[500px] h-[500px] opacity-[0.04]" style={{ background: 'radial-gradient(circle at center, oklch(var(--primary-500)), transparent 70%)' }} />

      <div className="absolute top-1/3 right-[10%] hidden lg:block">
        <div className="relative w-20 h-20">
          <div className="absolute inset-0 rounded-full border border-primary-500/20 animate-ping" style={{ animationDuration: '3s' }} />
          <div className="absolute inset-2 rounded-full border border-primary-500/30" />
          <div className="absolute inset-[30%] rounded-full bg-primary-500/10 flex items-center justify-center">
            <i className="ri-robot-2-line text-primary-500 text-lg"></i>
          </div>
        </div>
      </div>
      <div className="absolute bottom-1/4 left-[8%] hidden lg:block">
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 rounded-full border border-primary-500/15 animate-ping" style={{ animationDuration: '4s', animationDelay: '1s' }} />
          <div className="absolute inset-[25%] rounded-full bg-primary-500/5 flex items-center justify-center">
            <i className="ri-user-received-line text-primary-400 text-base"></i>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-10 pt-24 md:pt-28 pb-8 md:pb-12 flex flex-col items-start">
        <h1 ref={headlineRef} className={`font-display font-extrabold text-[34px] sm:text-[44px] md:text-[64px] leading-[1.05] tracking-tightest text-foreground-950 max-w-4xl reveal-fade-up ${headlineRevealed ? 'revealed' : ''}`}>
          Квалифицированные заявки для бизнеса с оплатой за результат через 5 дней
        </h1>

        <p ref={subtitleRef} className={`mt-4 md:mt-8 text-[15px] md:text-[19px] text-foreground-500 max-w-2xl leading-relaxed reveal-fade-up ${subtitleRevealed ? 'revealed' : ''}`}>
          Находим аудиторию с реальным спросом. ИИ сам начинает диалог, квалифицирует клиента и передаёт его вашему отделу продаж.
        </p>

        <div ref={advantagesRef} className={`mt-4 md:mt-6 flex flex-col gap-2.5 md:gap-3 reveal-fade-up ${advantagesRevealed ? 'revealed' : ''}`}>
          {advantages.map((adv) => (
            <div key={adv} className="flex items-center gap-2.5 md:gap-3">
              <span className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                <i className="ri-check-line text-primary-500 text-xs"></i>
              </span>
              <span className="text-[14px] md:text-[16px] text-foreground-700">{adv}</span>
            </div>
          ))}
        </div>

        <div ref={btnRef} className={`mt-6 md:mt-8 reveal-fade-up ${btnRevealed ? 'revealed' : ''}`}>
          <a
            href="https://t.me/anna_aigam"
            target="_blank"
            rel="noopener noreferrer"
            className="h-11 md:h-12 px-6 md:px-7 inline-flex items-center justify-center rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-[14px] md:text-[15px] font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            Рассчитать стоимость заявки в Telegram
          </a>
        </div>
      </div>
    </section>
  );
}